import type { ProjectAccess } from '../../types';
import { apiClient, handleApiError } from '../api-client';

/**
 * Get project access
 */
export const getProjectAccess = async (projectId: string) => {
  try {
    return apiClient.getPaginated<ProjectAccess>(`/projects/${projectId}/access`);
  } catch (error) {
    return handleApiError(error, 'Error fetching project access');
  }
};

/**
 * Remove a user's access to a project
 */
export const removeProjectAccess = async (projectId: string, userId: string) => {
  try {
    return apiClient.delete(`/projects/${projectId}/access/${userId}`);
  } catch (error) {
    return handleApiError(error, 'Error removing project access');
  }
};

/**
 * Leave a project
 */
export const leaveProject = async (projectId: string) => {
  try {
    return apiClient.delete(`/projects/${projectId}/access/me`);
  } catch (error) {
    return handleApiError(error, 'Error leaving project');
  }
};
